import pathfinder from '@fiverr-private/pathfinder';

export interface InspireRecommendationsAPIUrlResolverProps {
    relatedSubCategoryIds?: number[];
    seed?: number;
    amount?: number;
    cursor?: string;
}

export const resolveInspireRecommendationsApiUrl = ({
    relatedSubCategoryIds,
    seed,
    amount,
    cursor,
}: InspireRecommendationsAPIUrlResolverProps = {}): string => {
    const base = pathfinder('inspire_recommendations_api');
    const searchParams = new URLSearchParams('');

    if (relatedSubCategoryIds !== undefined) {
        relatedSubCategoryIds.forEach((id) => searchParams.append('relatedSubCategoryIds', `${id}`));
    }
    if (seed !== undefined) {
        searchParams.append('seed', `${seed}`);
    }
    if (amount !== undefined) {
        searchParams.append('amount', `${amount}`);
    }
    if (cursor !== undefined) {
        searchParams.append('cursor', cursor);
    }

    const searchParamsStr = searchParams.toString();
    if (!searchParamsStr) {
        return base;
    }

    return `${base}?${searchParamsStr}`;
};
